_ = require 'underscore'
{ PowerUpItemType } = require 'common/components/power-up'
BaseDirectoryView = require './base-directory-view'
DirectoryPluginItemView = require './directory-plugin-item-view'
PluginIOCache = require 'views/internal/plugins/plugin-io-cache'
React = require 'react'
t = require('views/internal/recup-with-helpers')('directory_enabled')

class DirectoryEnabledComponent extends React.Component
  displayName: 'Directory Enabled Power-Ups'

  render: t.renderable ->
    t.div '.directory-content-body', ->
      t.div '.directory-listing'

class DirectoryEnabledEmptyComponent extends React.Component
  displayName: 'Directory Enabled Power-Ups Empty State'

  render: t.renderable ->
    t.div '.directory-content-body.directory-enabled-empty', ->
      t.div '.directory-enabled-empty-text', ->
        t.p ->
          t.formatText 'there-are-no-power-ups-enabled-for-this-board'
        t.p ->
          t.formatText 'get-started-with-these-great-power-ups'
      t.div '.directory-listing'

module.exports = class DirectoryEnabledView extends BaseDirectoryView
  initialize: ({ @plugins, @currentPage, @directoryView }) ->
    super
    @listenTo @model, 'change:idOrganization change:powerUps', @frameDebounce @render
    @listenTo @model.boardPluginList, 'add remove reset', @frameDebounce @render

  # Returns 3 random plugins, but filter hidden/moderated ones first
  getPluginSuggestions: ->
    filteredPlugins = @directoryView.filterOutHiddenPlugins(@plugins)
    _.sample filteredPlugins, 3

  renderContent: ->
    @enabledPlugins = @directoryView.getEnabledPlugins()
    if @enabledPlugins.length
      return React.createElement DirectoryEnabledComponent
    else
      return React.createElement DirectoryEnabledEmptyComponent

  render: ->
    super
    contentContainer = @$el.find('.directory-listing')
    contentContainer.empty()

    if @enabledPlugins.length > 0
      listedPlugins = @enabledPlugins
      enabledPluginViews = _.map @enabledPlugins, (plugin) =>
        @subview(DirectoryPluginItemView, @model, {
          atomType: PowerUpItemType.Description
          @currentPage
          plugin
          @directoryView
        }, plugin.id)

      @appendSubviews(enabledPluginViews, contentContainer)


    else
      pluginSuggestions = @getPluginSuggestions()
      listedPlugins = pluginSuggestions
      powerUpSuggestionViews = _.map pluginSuggestions, (plugin) =>
        @subview(DirectoryPluginItemView, @model, {
          atomType: PowerUpItemType.Description
          @currentPage
          plugin
          @directoryView
        }, plugin.id)

      @appendSubviews(powerUpSuggestionViews, contentContainer)

    listedPowerUpsEnabled = _.intersection(_.map(listedPlugins, 'id'), _.map(@enabledPlugins, 'id'))

    @directoryView.trackScreenEvent 'boardDirectoryEnabledScreen',
      totalListed: listedPlugins.length
      totalListedEnabled: listedPowerUpsEnabled.length
      totalEnabled: @enabledPlugins.length
      allPowerUpsEnabled: _.map(@enabledPlugins, 'id')
      listedPowerUpsEnabled

    @



// WEBPACK FOOTER //
// ./app/scripts/views/directory/directory-enabled-view.coffee